<template>
    <div>
        <b-modal :okOnly="okOnly" :visible="showAlert">{{ this.$t(alertMessage) }}</b-modal>
    </div>
</template>

<script>
export default {
  props: {
    showAlert: {
      type: Boolean,
      default: false
    },
    alertMessage: {
      type: String,
      default: ''
    },
    okOnly: {
        type: Boolean,
        default: false
    }
  }
}
</script>